"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTransfers = exports.fetchTransaction = void 0;
var ExplorerService_1 = require("./ExplorerService");
Object.defineProperty(exports, "fetchTransaction", { enumerable: true, get: function () { return ExplorerService_1.fetchTransaction; } });
Object.defineProperty(exports, "fetchTransfers", { enumerable: true, get: function () { return ExplorerService_1.fetchTransfers; } });
//# sourceMappingURL=index.js.map